<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">{{ cardTitle }}</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            v-if="oldInfos?.id && !isEdit"
            @click="addGains"
            class="btn-action"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->

          <a-button
            @click="importsj()"
            class="btn-action"
            v-if="oldInfos?.id && !isEdit"
            >导入</a-button
          >
          <!-- <a-button
            class="btn-action"
            danger
            v-if="oldInfos?.id && !isEdit"
            type="text"
            @click="batchDelete"
          >
            批量移除</a-button
          > -->
        </span>
      </div>
    </div>

    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
      >
        <!-- :scroll="{ y: 290 }"
        :row-selection="rowSelection" -->
        <template slot="status" slot-scope="text, record, index">
          <!-- :defaultVisible="true" -->
          <a-tooltip placement="right" v-if="record.status != '2'">
            <template slot="title">
              <span v-if="record.operation == 'INSERT'">
                <div>新增当前数据</div>
                <div
                  v-for="item in insertDiff(record)"
                  :key="item.key || item.field"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}：{{ item.obj2 }}
                </div>
              </span>
              <span v-if="record.operation == 'UPDATE'">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  属性名称：原数据<span style="color: #3498db; font-size: 20px"
                    >→</span
                  >新数据
                </div>
                <div
                  v-for="item in diff(
                    record.changeTransContent,
                    record.nowTransContent
                  )"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}:<span>{{ item.obj1 }}</span>
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span>{{ item.obj2 }}</span>
                </div>
              </span>
              <span v-if="record.operation == 'DELETE'">删除当前数据.</span>
              <span v-if="text == '3'">驳回原因:{{ record.remark }}</span>
            </template>
            <div class="statuswz">
              <img
                src="@/assets/images/newadd.png"
                v-if="record.operation == 'INSERT'"
                title="新增"
              />
              <img
                src="@/assets/images/newedit.png"
                v-if="record.operation == 'UPDATE'"
                title="编辑"
              />
              <img
                src="@/assets/images/newdelete.png"
                v-if="record.operation == 'DELETE'"
                title="删除"
              />
              <!-- <img src="@/assets/images/back.png" v-if="record.operation==''" title="正确" /> -->
              <img
                src="@/assets/images/right.png"
                v-if="record.operation == ''"
                title="正常数据"
              />
              <div class="status-code status-orange" v-if="text == '0'"></div>
              <div class="status-code" v-if="text == '1'"></div>
              <div class="status-code status-red" v-if="text == '3'"></div>
              <div class="status-code status-gray" v-if="text == '4'"></div>
            </div>
          </a-tooltip>
          <div class="statuswz" v-else>
            <img src="@/assets/images/right.png" title="正确" />
          </div>
        </template>
        <template slot="sequenceNumber" slot-scope="text, record, index">
          <!-- 如果不需要分页或分页信息不存在，直接使用 index + 1 -->
          <span v-if="!pagination || !pagination.pageSize">{{
            index + 1
          }}</span>
          <!-- 否则计算全局序号 -->
          <span v-else>{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</span>
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="text == '其他'">{{ record.otherType }}</span>
          <span v-else>{{ text }}</span>
        </template>
        <span
          class="flex flex-around flex-wrap"
          slot="action"
          slot-scope="record"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="
              oldInfos &&
              oldInfos.id &&
              !isEdit &&
              record?.operation != 'DELETE' &&
              record?.status != '1' &&
              record?.status != '3'
            "
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="
              oldInfos && oldInfos.id && !isEdit && !record?.operation
            "
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && !isEdit && record?.operation"
            @click="cancelInfo(record)"
          >
            <img class="img-box" src="@/assets/images/cx.png" alt="" />
            <span>撤销</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && isEdit"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要移除待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '4'">您确定要移除已撤销的这条数据吗?</p>
      <p v-else>您确定要移除该条思政育人的数据吗?</p>
    </a-modal>
    <a-modal
      title="您确定撤销吗"
      :visible="showCancelModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOks"
      @cancel="showCancelModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要撤销待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '3'">您确定要撤销已驳回的这条数据吗?</p>
      <p v-else>您确定要撤销当前提交的数据吗?</p>
    </a-modal>
    <!-- 添加思政育人 -->
    <AddEducatingPeople
      ref="addEducatingPeople"
      @addEducatingPeople="addEducatingPeople"
    ></AddEducatingPeople>
    <data-import
      ref="dataImport"
      @refreshData="addEducatingPeople"
    ></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          :dataid="sj.id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import AddEducatingPeople from "./addEducatingPeople.vue";
import evidencelist from "@/components/common/evidencelist";
import { FIELD_LABELS } from "@/components/auditPage/data.js";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "类型",
    dataIndex: "productType",
    id: "productType",
    align: "center",
    width: 150,
  },
  {
    title: "名称/类别",
    dataIndex: "resourceCategory",
    id: "resourceCategory",
    align: "center",
  },
  {
    title: "数量",
    dataIndex: "resourceNum",
    id: "resourceNum",
    align: "center",
    width: 100,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 350,
    scopedSlots: { customRender: "action" },
  },
];
import mixin from "@/utils/mixin";
import changeStatusMixin from '@/utils/changeStatusMixin';
import brandListValidate from "./brandListValidate";
export default {
  mixins: [
    changeStatusMixin,
    mixin,
    // 数量仅「文化素材类的数字资源建设数量」必填，见 methods.validate
    brandListValidate("请添加思政育人"),
  ],
  data() {
    return {
      isBrandModule: false,
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isScore: false,
      isstatus: false,
      showCancelModel: false,
      fieldLabels: FIELD_LABELS[2]["PPSIZHENGYUREN"],
    };
  },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null && newValue != undefined && newValue) {
          if (
            this.$route.query.new == "preview" ||
            this.$parent?.news == "preview" ||
            (this.$parent.editInfo &&
              this.$parent.editInfo?.type == "preview") ||
            this.oldInfos?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.ensureStatusColumn(columns);
          this.emptyText = "暂无数据";
          this.addEducatingPeople();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
      immediate: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        if (
          this.$route.query.new == "preview" ||
          this.$parent?.news == "preview" ||
          this.$parent?.editInfo?.type == "preview" ||
          this.oldInfos?.type == "preview"
        ) {
          this.isEdit = true;
          return;
        }
        this.isEdit = newValue;
        // 教师角色下， 非负责模块不可编辑
        // if (this.$store.state.role == "teacher-role" && !this.isBrandModule) {
        //   this.isEdit = true;
        // }
      },
      immediate: true,
    },
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isRevise: {
      type: Boolean,
    },
    cardTitle: {
      type: String,
    },
  },
  components: {
    AddEducatingPeople,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  mounted() {
    const brandModules = this.$store.state.user.brandModules || ""; // 教师负责模块
    // 是否属于负责模块
    this.isBrandModule = brandModules.includes(this.cardTitle);
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    //this.getData();
  },
  methods: {
    // 覆盖 mixin：校本读本/育人模式不显示数量，数量仅文化素材类必填
    validate() {
      const CULTURAL_MATERIAL = "文化素材类的数字资源建设数量";
      const list = this.dataList || [];
      const pagedTotal =
        this.pagination &&
        typeof this.pagination === "object" &&
        this.pagination.total != null
          ? Number(this.pagination.total)
          : 0;
      if (list.length === 0 && pagedTotal <= 0) {
        this.$message.info("请添加思政育人");
        return false;
      }
      for (let i = 0; i < list.length; i++) {
        const row = list[i] || {};
        if (
          row.productType === null ||
          row.productType === undefined ||
          row.productType === ""
        ) {
          this.$message.info(`思政育人第 ${i + 1} 行的类型没有值，请填写`);
          return false;
        }
        if (
          row.resourceCategory === null ||
          row.resourceCategory === undefined ||
          row.resourceCategory === ""
        ) {
          const nameLabel =
            row.productType === CULTURAL_MATERIAL ? "类别" : "名称";
          this.$message.info(
            `思政育人第 ${i + 1} 行的${nameLabel}没有值，请填写`
          );
          return false;
        }
        if (row.productType === CULTURAL_MATERIAL) {
          if (
            row.resourceNum === null ||
            row.resourceNum === undefined ||
            row.resourceNum === ""
          ) {
            this.$message.info(`思政育人第 ${i + 1} 行的数量没有值，请填写`);
            return false;
          }
        }
      }
      return true;
    },
    cancelInfo(record) {
      this.showCancelModel = true;
      this.sj = record;
    },
    // 新增：处理操作后的数据刷新逻辑
    handleDataAfterOperation(currentPage, totalBefore) {
      // 计算删除后的总数据条数
      const totalAfter = totalBefore - 1;

      if (this.isstatus) {
        // 如果是状态模式，直接刷新数据
        this.getData();
      } else {
        // 计算删除后应该显示的页码
        const pageSize = this.pagination.pageSize;
        const totalPages = Math.ceil(totalAfter / pageSize);

        // 如果当前页没有数据了，且不是第一页，则显示上一页
        if (totalAfter > 0 && currentPage > totalPages) {
          this.pagination.current = Math.max(1, totalPages);
        } else {
          // 否则保持在当前页
          this.pagination.current = currentPage;
        }

        // 刷新数据
        this.getData();
      }
    },
    handleOks() {
      const currentPage = this.pagination.current;
      const totalBeforeCancel = this.pagination.total;
      let data = {
        ids: this.sj.taskId,
      };
      const req =
        this.sj?.status == "1" || this.sj?.status == "3"
          ? postAction("/audit/lxAuditTask/cancelTask?ids=" + this.sj.taskId, data)
          : deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
              id: this.sj.taskId,
            });
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success("撤销审核成功");
          this.showCancelModel = false;
          this.handleDataAfterOperation(currentPage, totalBeforeCancel);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    showevidence(record) {
      this.title = "思政育人";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init(
        "ideologicalPoliticalEducation",
        this.oldInfos,
        "思政育人"
      );
    },
    handleOk() {
      const currentPage = this.pagination.current;
      const pageSize = this.pagination.pageSize;
      const totalBeforeDelete = this.pagination.total;
      if (
        this.sj?.status == "1" ||
        this.sj?.status == "4" ||
        this.sj?.status == "0" ||
        this.sj?.status == "3" ||
        (this.sj?.status == "2" && this.sj?.operation)
      ) {
        deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
          id: this.sj.taskId,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.handleDataAfterOperation(currentPage, totalBeforeDelete);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        deleteAction("/lxbase/lxIdeologicalPoliticalEducation/delete", {
          id: this.deteleId,
          applyId: this.oldInfos?.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.handleDataAfterOperation(currentPage, totalBeforeDelete);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    addGains() {
      this.$refs.addEducatingPeople.init("add", this.oldInfos);
    },
    seeInfo(row) {
      this.$refs.addEducatingPeople.init("see", row);
    },
    addEducatingPeople() {
      if (!this.isstatus) {
        this.pagination.current = 1;
      }
      this.getData();
    },
    getData() {
      this.loading = true;
      // 确保页码不小于1
      if (this.pagination.current < 1) {
        this.pagination.current = 1;
      }
      if (this.isstatus && this.oldInfos?.id) {
        let data = {
          applyType: 2,
          // pageNo: this.pagination.current,
          // pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxbase/lxIdeologicalPoliticalEducation/allList", data).then(
          (res) => {
            if (res.code === 200) {
              let data = res.result.records;
              if (data) {
                this.dataList = data;
                // this.pagination.total = res.result.total;
              }
            }
            this.loading = false;
          }
        );
      } else {
        let data = {
          applyType: 2,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxbase/lxIdeologicalPoliticalEducation/list", data).then(
          (res) => {
            if (res.code === 200) {
              let data = res.result.records;
              if (data) {
                this.dataList = data;
                this.pagination.total = res.result.total;
                // 如果当前页没有数据，且不是第一页，则自动跳转到上一页
                if (data.length === 0 && this.pagination.current > 1) {
                  this.pagination.current -= 1;
                  this.getData(); // 重新获取上一页数据
                  return;
                }
              }
            }
            this.loading = false;
          }
        );
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.sj = row;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addEducatingPeople.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的思政育人");
      } else {
        const currentPage = this.pagination.current;
        const totalBeforeDelete = this.pagination.total;
        let params = {
          ids: this.selectedRowKeys.toString(),
          applyId: this.oldInfos?.id,
        };
        deleteAction(
          "/lxbase/lxIdeologicalPoliticalEducation/deleteBatch",
          params
        ).then((res) => {
          if (res.code == 200) {
            this.$message.success("批量移除成功");
            // this.pagination.current = 1;
            // this.getData();
            this.selectedRowKeys = [];
            // 处理批量删除后的页面逻辑
            const deleteCount = this.selectedRowKeys.length;
            const totalAfter = totalBeforeDelete - deleteCount;
            const pageSize = this.pagination.pageSize;
            const totalPages = Math.ceil(totalAfter / pageSize);

            // 如果当前页没有数据了，且不是第一页，则显示上一页
            if (totalAfter > 0 && currentPage > totalPages) {
              this.pagination.current = Math.max(1, totalPages);
            } else {
              // 否则保持在当前页
              this.pagination.current = currentPage;
            }

            this.getData();
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.statuswz {
  width: 100%;
  height: 54px;
  line-height: 54px;
  cursor: pointer;

  img {
    width: 20px;
    height: auto;
    margin: 0px auto;
  }

  .status-code {
    width: 40px;
    height: 40px;
    background: url("~@/assets/images/green-sj.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
  }

  .status-red {
    background: url("~@/assets/images/red-sj.png") no-repeat;
    background-size: 100% 100%;
  }

  .status-gray {
    background: url("~@/assets/images/hscx.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-orange {
    background: url("~@/assets/images/dtj.png") no-repeat;
    background-size: 100% 100%;
  }
}
.cotainer {
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}

.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}

.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }

  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }

  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
.btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
}
</style>
<style>
.ant-tooltip {
  max-width: 650px;
}

.ant-tooltip-arrow:before {
  background-color: #fff !important;
  width: 10px;
  height: 10px;
}

.ant-tooltip-inner {
  background-color: #fff !important;
  color: #3e3e3e !important;
  box-shadow: 0 0 12px 0 rgba(1, 39, 78, 0.27);
}
</style>